import React, { useEffect, useState, useContext } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { api } from '../api';
import { fetchToken, fetchRole } from '../auth/Token';
import { Box, Button, ButtonGroup, Typography,FormHelperText, Select, MenuItem,CircularProgress } from '@mui/material';
import Alert from '@mui/material/Alert';
import { DataGrid, GridToolbar, GridRowParams, GridActionsCellItem} from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useFormik, validateYupSchema } from 'formik';
import AuthContext from "../auth/AuthProvider";
import * as Yup from 'yup';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { toast } from 'sonner';



export const FormatedDate = ({value}) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const amOrPm = date.getHours() >= 12 ? 'PM' : 'AM';

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${amOrPm}`;
  return <span>{formattedDate}</span>;
}





export default function TransactionDetailsBnK({params, fetchTrs, fetchBnK, association_id}) {
    const [alert, setAlert] = useState()
    const [saveOpen, setSaveOpen] = React.useState(false);
    const [stampValue, setStampValue] = useState(null);
    const [stamp, setStamp] = useState(null);
    const [withdOpen, setWithdOpen] = useState(false);
    const {  permissions } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    
    
    //   const handleClose = () => {
    //     setOpen(false);
    //   };


    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      }));


    //   const handleClose = () => {
    //     setOpen_acc();
    //   };

    //   console.log(TransactionDetailsBnK)

      

      const handleDeposit = () => { 
        setSaveOpen(true)
      };
      const handleWithdraw = () => {
        setWithdOpen(true)
      };

      const closeDeposit = () => {
        formik.handleReset()
        setStamp(null)
        setSaveOpen(false)
        setLoading(false)
      };

      const closeWithdraw = () => {
        formik.handleReset()
        setWithdOpen(false)
        setLoading(false)
      };

    //   deposit
      const formik = useFormik({
        initialValues: {
            transaction_id:params.row.transaction_id,
            transaction_type: 1,
            Amount: params.row.amount,
            narration: params.row.narration,
            association_id: association_id,
            balance:params.row.balance,
            date: params.row.transaction_date
        },
        validationSchema: Yup.object({
            Amount: Yup.number()
                .required('Specify New Amount').min(0),
            narration: Yup.string()
        }),
        onSubmit: (values) => {
          setLoading(true)
            api.post('/association/update/transaction/depo', values , {
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response) {
                toast.success(response.data)
                formik.handleReset()
                setAlert()
                closeDeposit()
                fetchTrs() 
                fetchBnK()
            }).catch(function (error){
                // setAlert(<Alert severity="error">{error.response.data.detail}</Alert>)
                console.log(error)
            }).finally(function (){
              setLoading(false)
            })
          }
        })
    

    //   withdraw
    const formikk = useFormik({
        initialValues: {
            transaction_id:params.row.transaction_id,
            transactiontype_idd: 2,
            Amountt: params.row.amount,
            narrationn: params.row.narration,
            association_id: association_id,
            date: dayjs(params.row.transaction_date)
        },
        validationSchema: Yup.object({
            Amountt: Yup.number()
                .required('Specify Amount To Withdraw').min(1),
            narrationn: Yup.string()
        }),
        onSubmit: (values) => {
          setLoading(true)
          api.post('/association/update/transaction/depo/with', values , {
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }).then(function (response) {
            toast.success(response.data)
            formik.handleReset()
            setAlert()
            closeDeposit()
            fetchTrs() 
            fetchBnK()
        }).catch(function (error){
            // setAlert(<Alert severity="error">{error.response.data.detail}</Alert>)
            console.log(error)
        }).finally(function (){
          setLoading(false)
        })
        } 
      })

     
    //   console.log(transferInfo);
    const handleOpen = () => {
            params.row.transaction_type === 2
                ? handleWithdraw()
                : handleDeposit();
    };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <div>
        <IconButton onClick={handleOpen}><EditIcon /></IconButton>
        <Dialog open={saveOpen} onClose={closeDeposit}>
            <form onSubmit={formik.handleSubmit}>
            <DialogTitle>Transaction</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Edit
            </DialogContentText>
            
                 
                <TextField
                    margin="dense"
                    id="Amount"
                    name="Amount"
                    label="Amount"
                    onChange={formik.handleChange}
                    value={formik.values.Amount}
                    onBlur={formik.handleBlur}
                    error={formik.touched.Amount && Boolean(formik.errors.Amount)}
                    helperText={formik.touched.Amount && formik.errors.Amount}
                    type="number"
                    fullWidth
                    variant="outlined"
                />
                
            <TextField
                margin="dense"
                id="narration"
                name="narration"
                label="Narration (optional)"
                onChange={formik.handleChange}
                type="text"
                value={formik.values.narration}
                onBlur={formik.handleBlur}
                error={formik.touched.narration && Boolean(formik.errors.narration)}
                helperText={formik.touched.narration && formik.errors.narration}
                fullWidth
                variant="outlined"
            />
            
            <TextField
                id="date"
                name="date" 
                value={formik.values.date}
                onChange={formik.handleChange}
                type='datetime-local'
            />
             {/* <DateTimePicker
                id="date"
                name="date" 
                value={formik.values.date}
                onChange={(date) => formik.setFieldValue('date', date)}
                orientation="landscape"
            /> */}
            
            </DialogContent>
            <DialogActions>
            <Button onClick={closeDeposit}>Cancel</Button>
            <Button
                 type='submit'
                >
                    { loading === true ? 
                     <Box sx={{ width: '100%' }}>
                        <CircularProgress />
                    </Box>
                    :
                    "Save"
                    }
                </Button>
            </DialogActions>
            </form>
        </Dialog>

            {/* withdraw */}
        <Dialog open={withdOpen} onClose={closeWithdraw}>
            <form onSubmit={formikk.handleSubmit}>
            <DialogTitle>Transaction</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Edit
            </DialogContentText>
                <TextField
                    margin="dense"
                    id="Amountt"
                    name="Amountt"
                    label="Amount to withdraw"
                    onChange={formikk.handleChange}
                    value={formikk.values.Amountt}
                    onBlur={formikk.handleBlur}
                    error={formikk.touched.Amountt && Boolean(formikk.errors.Amountt)}
                    helperText={formikk.touched.Amountt && formikk.errors.Amountt}
                    type="number"
                    fullWidth
                    variant="outlined"
                />
                

            <TextField
                margin="dense"
                id="narrationn"
                name="narrationn"
                label="Narration (optional)"
                onChange={formikk.handleChange}
                type="text"
                value={formikk.values.narrationn}
                onBlur={formikk.handleBlur}
                error={formikk.touched.narrationn && Boolean(formikk.errors.narrationn)}
                helperText={formikk.touched.narrationn && formikk.errors.narrationn}
                fullWidth
                variant="outlined"
            />

            <DateTimePicker 
                id="date"
                name="date" 
                value={formikk.values.date}
                onChange={(date) => formikk.setFieldValue('date', date)}
                orientation="landscape"
            />
            
            </DialogContent>
            <DialogActions>
            <Button onClick={closeWithdraw}>Cancel</Button>
            <Button
                 type='submit'
                >
                    { loading === true ?   
                     <Box sx={{ width: '100%' }}>
                        <CircularProgress />
                    </Box>
                    :
                    "Save"
                    }
                </Button>
            </DialogActions>
            </form>
        </Dialog>
    </div>
    </LocalizationProvider>
  )
}
